/**
 * @generated SignedSource<<6501ce1a0d77956a088e09b011f8c061>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer$data = {
  readonly fieldId: string;
  readonly selectedAffectedServicesConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly serviceId: string;
      };
    } | null | undefined>;
  };
  readonly " $fragmentType": "sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer";
} | null | undefined;
export type sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer$key = {
  readonly " $data"?: sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "fieldId"
      },
      "action": "THROW",
      "path": "fieldId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraAffectedServiceConnection",
        "kind": "LinkedField",
        "name": "selectedAffectedServicesConnection",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraAffectedServiceEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraAffectedService",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "kind": "ScalarField",
                          "name": "serviceId"
                        },
                        "action": "NONE",
                        "path": "selectedAffectedServicesConnection.edges.node.serviceId"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "kind": "ScalarField",
                          "name": "name"
                        },
                        "action": "NONE",
                        "path": "selectedAffectedServicesConnection.edges.node.name"
                      }
                    ]
                  },
                  "action": "NONE",
                  "path": "selectedAffectedServicesConnection.edges.node"
                }
              ]
            },
            "action": "NONE",
            "path": "selectedAffectedServicesConnection.edges"
          }
        ]
      },
      "action": "NONE",
      "path": "selectedAffectedServicesConnection"
    }
  ],
  "type": "JiraAffectedServicesField"
};

(node as any).hash = "588c820b68fb8df2d8934a0c9e94cdf5";

export default node;
